import { i18n } from "@pathwright/ui/src/components/lng/I18nextProvider"
import { printContent } from "lib/core/utils/print"

let NotePanelView
require("./styles/note-panel.css")

const NotePathListView = require("note/views/note-path-list").default
const NoteFormView = require("./note-form").default
const BaseModel = require("lib/utils/model").default
const NoteListItemView = require("note/views/note-list-item").default
const NoteBlankSlateView = require("note/views/note-blank-slate").default
const Note = require("note/models/note").default

export default NotePanelView = (function () {
  NotePanelView = class NotePanelView extends (
    require("lib/static-shim").default(require("lib/core/layout").default)
  ) {
    static initClass() {
      this.prototype.template = require("./templates/note-panel.html")
      this.prototype.className = "note-panel-view"

      this.prototype.regions = { noteRegion: "#notes" }

      this.prototype.ui = { noteActions: ".note-actions" }

      this.prototype.triggers = {
        "click .expand-notes": "expand:notes",
        "click .collapse-notes": "collapse:notes",
        "click .print-notes": "print:notes",
        "click .note-breadcrumb": "previous:state"
      }

      this.prototype.behaviors = {
        ConnectStore: {
          stores: [
            { store: "path" },
            {
              store: "note",
              events: {
                "note:removed": "onNoteRemoved",
                "change:item": "setHeaderTitle"
              }
            }
          ]
        },

        Vents: {
          "add:note"(pathItem) {
            window.App.getStore("note").action.setItem(
              pathItem.get("sync_source_id")
            )
            this.triggerMethod("change:state", "form")
          },

          "show:note:form"(note) {
            window.App.getStore("note").action.setItem(note.get("context").step)
            return this.triggerMethod("change:state", "form", note)
          }
        }
      }
    }

    initialize() {
      ;({
        title: this.title,
        target_id: this.target_id,
        notes: this.notes
      } = this.options)

      this.model = new BaseModel({
        header_title: i18n.t("notes.notes_for", {
          title: this.title
        })
      })

      return this.initState()
    }

    // The state model keeps track of whether or not to show
    // the breadcrumb nav and what view should be shown
    // when the breadcrum nav is clicked
    initState() {
      this.state = new BaseModel({
        previous: [],
        ignore: ["form"]
      })

      return this.listenTo(this.state, "change:current", function () {
        const current = this.state.get("current")
        if (!current) {
          App.getStore("layout").action.closeIn("panel")
        }
        const i = this.state.get("ignore").indexOf(current)
        // Show the breadcrumb nav if there is a previous state
        // to show and the current state allows for breadcrumb navigation
        if (this.state.get("previous").length && i === -1) {
          const text = _.last(this.model._snaps).header_title
          this.$(".note-breadcrumb").show()
          return this.$(".note-breadcrumb #breadcrumb").text(text)
        } else {
          return this.$(".note-breadcrumb").hide()
        }
      })
    }

    onExpandNotes() {
      return Pathwright.vent.trigger("expand:notes")
    }

    onCollapseNotes() {
      return Pathwright.vent.trigger("collapse:notes")
    }

    onPrintNotes() {
      Pathwright.vent.trigger("before:print:notes")
      printContent(".note-container")
    }

    // Set the navigation state.
    setState(current) {
      const i = this.state.get("previous").indexOf(current)
      const previous = this.state.get("previous").slice(0, +i + 1 || undefined)
      const wasCurrent = this.state.get("current")

      if (_.last(previous) === current) {
        previous.pop()
      } else if (this.state.get("ignore").indexOf(wasCurrent) === -1) {
        if (wasCurrent) {
          previous.push(wasCurrent)
        }
      }

      return this.state.set({
        previous,
        current
      })
    }

    onPreviousState(note) {
      this.model.rollback()
      const current = _.last(this.state.get("previous"))
      return this.triggerMethod("change:state", current, note)
    }

    onChangeState(state, note) {
      this.setState(state)
      return this.triggerMethod(`show:note:${this.state.get("current")}`, note)
    }

    onRender() {
      // Show an "empty" view if no notes
      if (!this.notes.length) {
        this.options.view = "blank"
      }
      if (this.target_id) {
        if (
          !this.noteStore.getState().notes_per_target[this.target_id]
            .total_notes
        ) {
          this.options.view = "blank"
        }
      }
      return this.triggerMethod("change:state", this.options.view)
    }

    // Empty view for if there are no notes to show
    onShowNoteBlank() {
      let message
      this.ui.noteActions.hide()
      const { can_post_note } =
        window.App.getStore("note").request.getNotePermissions()
      // If there is no group, then there are no path items to
      // add a note to. Passing a disabledMessage to the blank slate
      // will disable the add note button and will add a popover with the message
      if (can_post_note && !this.getFirstNotableItem()) {
        message = "First, you'll need to create a group or step."
      }

      this.view = new NoteBlankSlateView({
        title: this.title,
        disabledMessage: message
      })
      this.noteRegion.show(this.view)

      if (can_post_note) {
        this.listenTo(this.view, "add:note", function () {
          if (this.target_id == null) {
            this.target_id = __guard__(this.getFirstNotableItem(), (x) =>
              x.get("sync_source_id")
            )
          }
          window.App.getStore("note").action.setItem(this.target_id)
          return this.triggerMethod("change:state", "form")
        })
      }
    }

    onShowNoteList() {
      const grouping = this.getGrouping()

      this.ui.noteActions.css("display", "inline-block")
      if (!grouping.length) {
        this.ui.noteActions.hide()
      }

      this.view = new NotePathListView({
        collection: new Backbone.Collection(grouping)
      })
      return this.noteRegion.show(this.view)
    }

    getGrouping() {
      // get the item by id
      let selected = this.noteStore.request.getItemBySourceID(this.target_id)
      if (selected) {
        selected = [selected]
      }
      // return found item or all groups and steps
      return (
        selected ||
        this.pathStore.get("items").filter((item) => {
          const target = this.noteStore.request.getTargetForItem(item)
          // Only select the root-level items since we render notes like a tree.
          return !item.get("parent") && target?.total_notes
        })
      )
    }

    // Get's first item in path that can receive a note
    getFirstNotableItem() {
      const items = this.pathStore.get("items").models
      if (items != null ? items.length : undefined) {
        let pathItem
        return (pathItem = _.first(
          Array.from(items)
            .filter(
              (item) =>
                item.get("item_type") === "G" || item.get("item_type") === "R"
            )
            .map((item) => item)
        ))
      } else {
        return null
      }
    }

    onShowNoteItem(note) {
      this.view = new NoteListItemView({
        model: note,
        expanded: true
      })
      return this.noteRegion.show(this.view)
    }

    // TODO: shrink this function
    onShowNoteForm(note) {
      if (note == null) {
        note = new Note()
      }
      const stepId = window.App.getStore("note").getState().item.sync_source_id
      this.model.snapshot()
      this.setHeaderTitle()

      // Get the filter menu data
      const data = this.noteStore.request.getNoteFilterMenuData(stepId)

      this.view = new NoteFormView({
        model: note,
        placeholder: this.model.get("header_title"),
        filterData: data
      })
      this.noteRegion.show(this.view)

      this.ui.noteActions.hide()
      // listen for when note is canceled
      this.listenToOnce(this.view, "cancel:note", function () {
        return this.triggerMethod("previous:state", note)
      })
      const isNew = !note.id
      // listen for when note is saved
      return this.listenToOnce(this.view, "save:note", function (note) {
        if (isNew) {
          this.options.onCreateNote && this.options.onCreateNote(note)
        }
        this.triggerMethod("change:state", "list")
      })
    }

    _getPathItemTitle() {
      const item = window.App.getStore("note").getState().item
      return item ? item.name : ""
    }

    setHeaderTitle() {
      const headerTitle = this._getPathItemTitle()
      if (this.model) {
        this.model.set({ header_title: headerTitle })
      }
      this.options.setHeader({
        title: headerTitle
      })
    }

    onNoteRemoved(note) {
      this.options.onDeleteNote && this.options.onDeleteNote(note)

      const item = this.noteStore.request.getItemBySourceID(
        note.get("context").step
      )

      // attempt to close panel if the target has no more notes or the note store has no more notes
      return _.delay(() => {
        if (note.get("context").step === this.target_id) {
          if (!this.noteStore.request.getTargetForItem(item).total_notes) {
            App.getStore("layout").action.closeIn("panel")
          }
        }
        if (this.target_id == null) {
          if (!this.notes.length) {
            return App.getStore("layout").action.closeIn("panel")
          }
        }
      }, 400)
    }
  }
  NotePanelView.initClass()
  return NotePanelView
})()

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
